module.exports = __webpack_public_path__ + "static/img/logo.9280ab9.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/logo.png
// module id = 1QZ/
// module chunks = 1